export const priceListItems = [
    {
        title: 'Tratamente și remodelare corporală',
        items: [
            { title: 'Tunel Infraroșu (55 min)', price: '80 lei' },
            { title: 'Abonament 10 ședințe (Tunel Infraroșu) (55 min)', price: '600 lei' },
            { title: 'Presoterapie (55 min)', price: '100 lei' },
            { title: 'Abonament 10 ședințe (Presoterapie) (55 min)', price: '700 lei' },
            { title: 'Solar (per minut) (1 min)', price: '3 lei' },
            { title: 'Abonament 100 min (Solar) (1 h 40 min)', price: '230 lei' },
        ],
    },
    {
        title: 'Manichiura & Pedichiura',
        items: [
            { title: 'Ojă semipermanentă (1 h 30 min)', price: '110 lei' },
            { title: 'Pedichiură (1 h 30 min)', price: '110 lei' },
            { title: 'Construcție scurtă (tipsuri reutilizabile/șablon) (1 h 30 min)', price: '150 lei' },
            { title: 'Construcție medie (tipsuri reutilizabile/șablon) (2 h 30 min)', price: '200 lei' },
            { title: 'Construcție lungă (tipsuri reutilizabile/șablon) (3 h)', price: '250 lei' },
            { title: 'Întreținere scurtă + design (1 h 30 min)', price: '130 lei' },
            { title: 'Întreținere medie + design (2 h)', price: '180 lei' },
            { title: 'Întreținere lungă + design (2 h 30 min)', price: '210 lei' },
            { title: 'Mărime scurtă + design (1 h 30 min)', price: '170 lei' },
            { title: 'Mărime medie + design (2 h)', price: '250 lei' },
            { title: 'Mărime lungă + design (2 h 30 min)', price: '300 lei' },
        ],
    },
    {
        title: 'Epilare Definitivă',
        items: [
            { title: 'Full Body (1 h 30 min)', price: '300 lei' },
            { title: 'Picioare integral (30 min)', price: '250 lei' },
            { title: 'Picioare scurt (30 min)', price: '150 lei' },
            { title: 'Brațe integral (30 min)', price: '150 lei' },
            { title: 'Brațe scurt (30 min)', price: '75 lei' },
            { title: 'Inghinal total (30 min)', price: '200 lei' },
            { title: 'Fese (30 min)', price: '90 lei' },
            { title: 'Abdomen (30 min)', price: '70 lei' },
            { title: 'Lombar (30 min)', price: '80 lei' },
            { title: 'Axile (30 min)', price: '60 lei' },
            { title: 'Axile + Inghinal (50 min)', price: '220 lei' },
            { title: 'Mustață (30 min)', price: '50 lei' },
            { title: 'Perciuni (30 min)', price: '50 lei' },
            { title: 'Față integral (30 min)', price: '100 lei' },
            { title: 'Abonament (6 ședințe) Full Body (1 h 30 min)', price: '1600 lei' },
        ],
    },
    {
        title: 'HIFU',
        items: [
            { title: 'Bărbie (25 min)', price: '190 lei' },
            { title: 'Facial (1 h 10 min)', price: '300 lei' },
            { title: 'Corporal pe zonă (1 h 30 min)', price: '450 lei' },
        ],
    },
    {
        title: 'Hidrafacial (tratamente)',
        items: [
            { title: 'Tratament Facial (1 h 15 min)', price: '190 lei' },
            { title: 'Tratament Facial cu peeling (1 h 30 min)', price: '250 lei' },
            { title: 'Tratament Hidrafacial (1 h 30 min)', price: '250 lei' },
            { title: 'Rejuvenare (1 h 30 min)', price: '250 lei' },
        ],
    },
];